import Cookies from 'js-cookie'
import Config from '@/settings'

const TokenKey = Config.TokenKey
const RefreshTokenKey = 'Refresh-Token'

export function getToken () {
  return Cookies.get(TokenKey)
}

export function getRefreshToken () {
  return Cookies.get(RefreshTokenKey)
}

export function setToken (token, rememberMe) {
  if (rememberMe) {
    return Cookies.set(TokenKey, token, { expires: Config.tokenCookieExpires })
  } else return Cookies.set(TokenKey, token)
}

export function setRefreshToken (token) {
  return Cookies.set(RefreshTokenKey, token)
}

export function removeToken () {
  Cookies.remove(RefreshTokenKey)
  return Cookies.remove(TokenKey)
}
